module.exports = __webpack_public_path__ + "img/second-day-11.a344e297.png";